<template>
  <v-overlay :value="loading.status" z-index="9999">
    <v-progress-circular v-if="loading.circular" indeterminate size="64" />
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OverlayLoading",
  computed: {
    ...mapGetters(["loading"]),
  },
};
</script>
